import { axiosNTL , axiosNL, axiosNT} from '../../../services/axios';

const getMandatoryTags = () => axiosNTL
  .get(`/courseTag/getMandatoryTags`)
  .then((res : any ) => {
      const users = res.responseObject; 
      return Promise.resolve(users);
  });
  
const getOptionalTags = () => axiosNT
  .get(`/courseTag/getOptionalTags`)
  .then((res : any ) => {
      const users = res.responseObject; 
      return Promise.resolve(users);
  });
  
const getSearchIntructors = (selectedString: string, search: string) => axiosNT
  .get(`/package/getInstructors?name=${search}&selectedInstructor=${selectedString}`)
  .then((res : any ) => {
      const users = res.responseObject; 
      return Promise.resolve(users);
  });

const searchBatches = (selectedString: string, search: string) => axiosNT
  .get(`/package/getBatches?selectedBatch=${selectedString}&name=${search}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const searchSyllabus = (selectedString: string, search: string) => axiosNT
  .get(`/package/searchSyllabus?courseIds=${selectedString}&name=${search}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const updateSettings = (courseId: string, parameters: any) => axiosNT
  .post(`/package/updateCourseSetting/${courseId}`, parameters)
  .then((res: any) => {
    const users = res;
    return Promise.resolve(users);
});

const mapMoreChapter = (courseId: string) => axiosNTL
  .get(`/package/getCourseChapters?courseIds=${courseId}`)
  .then((res: any) => {
    const response = res.responseObject;
    return Promise.resolve(response);
});


  
export default {
  getMandatoryTags,
  getOptionalTags,
  getSearchIntructors,
  searchBatches,
  searchSyllabus,
  updateSettings,
  mapMoreChapter
};